import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import React, { useState } from "react"
import { useLocation } from "@reach/router"
import * as style from "./style.module.css"
import json from "/src/siteData.json"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faFacebookSquare,
  faInstagram,
  faLine,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons"
import { faNewspaper } from "@fortawesome/free-solid-svg-icons"

const pageConstruct = json.pageConstruct
const siteMetaData = json.siteMetadata
const data = json.footer

const loadGoogleFonts = () => {
  const link = document.createElement('link');
  link.href = "https://fonts.googleapis.com/css2?family=M+PLUS+Rounded+1c&display=swap";
  link.rel = 'stylesheet';
  document.head.appendChild(link);
};

const Component = () => {
  const [isOpen, setIsOpen] = useState(false)
  const location = useLocation()
  const isTopPage = location.pathname === "/"
  const logoClass = isTopPage ? style.logo_topPage : style.logo_otherPage

  return (
    <header className={style.container}>
      <Link to="/" className={style.logo}>
        <StaticImage
          src="../../images/icon/logo.png"
          alt="ロゴ画像"
          width={400}
        />
      </Link>

      <div className={style.contactwrap_pc}>
        <Link to="/contact" className={style.contact_button}>
              <div className={logoClass}>お問い合わせ</div>
        </Link>
      </div>

      <div className={style.contactwrap_sp}>
        <Link to="/contact" className={style.contact_button}>
              <div className={logoClass}>お問い合わせ</div>
        </Link>
      </div>



      <button
        className={style.menu}
        onClick={() => {
          setIsOpen(!isOpen)
        }}
      >
        {!isOpen ? (
          isTopPage ? (
            <StaticImage
              src="../../images/icon/menu_open.svg"
              loading="eager"
              formats={["auto", "webp", "avif"]}
              alt="開く"
            />
          ) : (
            <StaticImage
              src="../../images/icon/menu_open.svg"
              loading="eager"
              formats={["auto", "webp", "avif"]}
              alt="開く"
            />
          )
        ) : (
          <StaticImage
            src="../../images/icon/menu_close.svg"
            loading="eager"
            formats={["auto", "webp", "avif"]}
            alt="閉じる"
          />
        )}
      </button>
      <div className={`${style.nav} ${isOpen ? style.nav_open : ""}`}>
        <nav className={style.nav_container}>
          <ul className={style.nav_list}>
            {/* {pageConstruct.map((props, index) => {
              if (props.type === 4) {
                return (
                  <>
                    <li className={style.nav_item} key={index}>
                      <Link to="/menu/">MENU</Link>
                    </li>
                    <li className={style.nav_item} key={index}>
                      <Link to={`/${props.slug}/p/1`}>{props.name}</Link>
                    </li>
                  </>
                )
              }
              if (props.type === 1) {
                return (
                  <li className={style.nav_item} key={index}>
                    <Link to="/">{props.name}</Link>
                  </li>
                )
              }
              if (props.type !== 5) {
                return (
                  <li className={style.nav_item} key={index}>
                    <Link to={`/${props.slug}`}>{props.name}</Link>
                  </li>
                )
              }
              return null
            })} */}


            <li className={style.nav_item}>
              <Link to="/">ホーム</Link>
              </li>
            <li className={style.nav_item}>
              <Link to="/concept">こだわり</Link>
            </li>
            <li className={style.nav_item}>
              <Link to="/lesson">レッスン・料金</Link>
            </li>
            <li className={style.nav_item}>
              <Link to="/teacher">先生の事</Link>
            </li>
            <li className={style.nav_item}>
              <Link to="/eurhythmics">リトミック</Link>
            </li>
            <li className={style.nav_item}>
              <Link to="/school">教室概要</Link>
            </li>
            <li className={style.nav_item}>
              <Link to="/blog/p/1">お知らせ</Link>
            </li>

            <li className={style.nav_item}>
              <Link to="/contact">お問い合わせ</Link>
            </li>

          </ul>
        </nav>

        <div>
          <div className={style.sns}>
            <ul className={style.sns_list}>
              {/* {data.facebookUrl && (
                <li className={style.sns_item}>
                  <Link to={data.facebookUrl}>
                    <FontAwesomeIcon
                      icon={faFacebookSquare}
                      style={{ fontSize: "2.2rem" }}
                      color="var(--color-dark)"
                    />
                  </Link>
                </li>
              )} */}
              {data.instagramUrl && (
                <li className={style.sns_item}>
                  <Link to={data.instagramUrl}>
                    <FontAwesomeIcon
                      icon={faInstagram}
                      style={{ fontSize: "2.2rem" }}
                      color="var(--color-dark)"
                    />
                  </Link>
                </li>
              )}
              {data.lineUrl && (
                <li className={style.sns_item}>
                  <Link to={data.lineUrl}>
                    <FontAwesomeIcon
                      icon={faLine}
                      style={{ fontSize: "2.2rem" }}
                      color="var(--color-dark)"
                    />
                  </Link>
                </li>
              )}
              {/* {data.xUrl && (
                <li className={style.sns_item}>
                  <Link to={data.xUrl}>
                    <FontAwesomeIcon
                      icon={faXTwitter}
                      style={{ fontSize: "2.2rem" }}
                      color="var(--color-dark)"
                    />
                  </Link>
                </li>
              )} */}
              {/* {data.blogUrl && (
                <li className={style.sns_item}>
                  <Link to={data.blogUrl}>
                    <FontAwesomeIcon
                      icon={faNewspaper}
                      style={{ fontSize: "2.2rem" }}
                      color="var(--color-dark)"
                    />
                  </Link>
                </li>
              )} */}
            </ul>
          </div>

          <div className={style.nav_bottom}>
            <Link to="/agreements">プライバシーポリシー</Link>
            <p>&copy; {siteMetaData.title}</p>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Component
